var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio align-items-start",class:{
    'radio-list':!_vm.inline,
    'radio-inline': _vm.inline
}},_vm._l((_vm.options),function(optionValue,optionTitle){return _c('label',{staticClass:"radio"},[_c('input',{attrs:{"type":"radio","name":_vm.id},domProps:{"value":optionValue,"checked":optionValue === _vm.value},on:{"change":function($event){return _vm.$emit('input', optionValue)}}}),_vm._v(" "),_c('span'),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(optionTitle)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }